import { Component, OnInit, inject } from '@angular/core';
import { ModalOptions } from '@shared/models';
import { ModalService } from '@shared/services';

@Component({
  selector: 'lib-save-billing-org-modal',
  templateUrl: 'save-billing-org-modal.component.html',
})
export class SaveBillingOrgModalComponent implements OnInit {
  private readonly modalService = inject(ModalService);
  public options: ModalOptions | undefined;

  public ngOnInit() {
    this.options = this.modalService.options;
  }

  public onCancelSave() {
    this.modalService.dismiss();
  }

  public onSaveChanges() {
    this.modalService.close(true);
  }

  public onDontSaveChanges() {
    this.modalService.close(false);
  }
}
